module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/container-bars-mobile-74b6d4b09c0fc41c3b4cbe0ba40c2fd7.png";